module.exports = __webpack_public_path__ + "static/media/notco.5f6610d0.png";